import(/* webpackMode: "eager" */ "/app/app/news/[...slug]/error.tsx");
